import classnames from 'classnames';

import style from './AddFieldButton.module.scss';

import { Icon, IconType } from '@components/Icon';

export interface AddFieldButtonParams {}

interface AddFieldButtonProps extends AddFieldButtonParams {
    label?: string;
    disabled?: boolean;
    dataTest?: string;
    onAddClick(): void;
}

export function AddFieldButton({ label, disabled, dataTest, onAddClick }: AddFieldButtonProps) {
    return (
        <div
            className={classnames([style.root, disabled && style.root_disabled])}
            data-test={dataTest}
            data-testid={dataTest}
            onClick={!disabled ? onAddClick : undefined}
        >
            {label ? (
                label
            ) : (
                <div className={style.addIcon}>
                    <div className={style.iconWrapper}>
                        <Icon type={IconType.CROSS} />
                    </div>
                </div>
            )}
        </div>
    );
}
